module.exports = __webpack_public_path__ + "static/media/img-upload-photo.f2af9a85.svg";